import { render, staticRenderFns } from "./negocios.vue?vue&type=template&id=13b53b26&scoped=true&"
import script from "./negocios.vue?vue&type=script&lang=js&"
export * from "./negocios.vue?vue&type=script&lang=js&"
import style0 from "./negocios.vue?vue&type=style&index=0&id=13b53b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b53b26",
  null
  
)

export default component.exports